const INITIAL_STATE = {
  data: {},
  errors: {}, 
}
      
const workOrderDetail = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_WORK_ORDER_DETAIL':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_WORK_ORDER_LIST_DETAIL':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default workOrderDetail;
      